/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 fireplace_optimized.glb -T -t -f -R 512 
Files: fireplace_optimized.glb [102.88KB] > /Users/jay/Documents/dev/threejs-challenge/cozy-place/public/models/fireplace_optimized-transformed.glb [34.32KB] (67%)
*/

import * as THREE from 'three/webgpu';
import { useGLTF } from '@react-three/drei';
import type { GLTF } from 'three/examples/jsm/Addons.js';
import type { ThreeElements } from '@react-three/fiber';

type GLTFResult = GLTF & {
  nodes: {
    cooking_fire: THREE.Mesh;
  };
  materials: {
    cooking_fire_mat: THREE.MeshStandardMaterial;
  };
};

export function CookingMesh(props: ThreeElements['group']) {
  const { nodes, materials } = useGLTF(
    '/models/fireplace_optimized-transformed.glb'
  ) as unknown as GLTFResult;
  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.cooking_fire.geometry}
        material={materials.cooking_fire_mat}
      />
    </group>
  );
}

useGLTF.preload('/models/fireplace_optimized-transformed.glb');
